var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternal = function SvgIconExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.084 3.076a.76.76 0 0 0-.757.758v7.742a.76.76 0 0 0 .757.757h7.742a.76.76 0 0 0 .758-.757V8.353a.65.65 0 0 1 1.3 0v3.223a2.057 2.057 0 0 1-2.058 2.057H4.084a2.057 2.057 0 0 1-2.057-2.057V3.834a2.06 2.06 0 0 1 2.057-2.058h3.223a.65.65 0 1 1 0 1.3zm4.812-.65a.65.65 0 0 1 .65-.65h3.688a.65.65 0 0 1 .65.65v3.721a.65.65 0 1 1-1.3 0V3.996L7.266 9.313a.65.65 0 1 1-.92-.919l5.319-5.318h-2.12a.65.65 0 0 1-.65-.65",
    clipRule: "evenodd"
  })));
};
export default SvgIconExternal;